module.exports = __webpack_public_path__ + "img/logoload.89f9cea3.svg";